// extracted by mini-css-extract-plugin
export default {"menu":"NavList_menu__9jNj+","navList":"NavList_navList__dq3d1","active":"NavList_active__alCl8"};